export default __webpack_public_path__ + "static/signax-09f37073c75caaaeaff58568652bcd2d.png";